
<template>
  <div>
    <div>
      <check-profile v-if="oneCheck && oneCheck.data" :can_show_actions='false'></check-profile>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import CheckProfile from './CheckProfile.vue'

export default {
  name: 'CheckDetail',
  components: {
    CheckProfile,
  },
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {
      
    },
    ...mapMutations({
      setOneCheck: 'Financial/getOneFinancial'
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      oneCheck: state => state.Financial.oneCheck,
    })
  },
  mounted () {
    this.setOneCheck({item: this.item, kind: 'checks'});
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>